module.exports = __webpack_public_path__ + "static/media/mon-salwa.6dce6bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/mon-salwa.png
// module id = 269
// module chunks = 0